<template>
  <div>
     <!--NEW/Added Mortgage-->
    <div class="row no-gutters mt-1">
        <div class="col-12 py-2 pl-2 product-section-heading text-white rounded-top">
        <div role="heading" aria-level="2">Manually add Mortgage(s) to the policy.</div>
        </div>
        <div class="col-12 py-2 shadow-sm rounded-bottom">
        <!--added Mortgage -->
        <div class="d-inline-block w-100">
             <button type="button" class="add-button btn btn-outline-success px-1 wsn select list-item px-3"
                tabindex="0" @keydown.enter.prevent.stop="addNewRuleForProperty(UrlAPI, 'mortgage')"
                @click.prevent="addNewRuleForProperty(UrlAPI, 'mortgage')"  v-if="isInvisible() &&!isPolicyBound()">
                <icon name="plus-circle" scale="1.1" class="d-block mx-auto float-left"></icon>
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">Add Mortgage</div>
            </button>
            <template v-for="(sectionButton, ndKey) in allSections">
            <button type="button" class="vd-btn btn px-3 wsn select list-item" tabindex="0" :key="ndKey+'_non_add_veh'">
                <i  class="fas fa-home float-left pt-1"></i>
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">
                {{ sectionButton }}</div>
                <a href="JavaScript:void(0);" v-if="sectionButton !== 'Primary Mortgage' && !isPolicyBound()"
                @keydown.enter.prevent.stop="promptDeleteSection(`remove-claim-modal_${ndKey}`)"
                @click.stop="promptDeleteSection(`remove-claim-modal_${ndKey}`)" class="delete"
                aria-label="remove mortgage" tabindex="0"
                ></a>
                <!-- <div class="check" v-if="ndData.status === 'IncludedComplete'"></div> -->
                  <!--  remove modal -->
         <div>
         <b-modal :ref="`remove-claim-modal_${ndKey}`" hide-header hide-footer hide-header-close no-enforce-focus>
              <Trapclaim :group="`remove-modal`">
                <div class="remove-confirmation-box">
                  <div class="remove-modal-message mb-3">
                    <div>Are you sure you want to remove this Mortgage?</div>
                  </div>
                  <div class="remove-modal-sep mt-1 mb-1"></div>
                  <div class="remove-btn-box">
                    <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block
                    @keydown.enter.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)"
                    @keydown.space.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)" @click.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)">Cancel</b-button>
                    <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @keydown.enter.prevent.stop="deleteSectionRc2(sectionButton, `remove-claim-modal_${ndKey}`,'mortgage')"
                    @keydown.space.prevent.stop="deleteSectionRc2(sectionButton, `remove-claim-modal_${k}`,'mortgage')" @click.prevent.stop="deleteSectionRc2(sectionButton, `remove-claim-modal_${ndKey}`,'mortgage')">
                      Remove</b-button>
                  </div>
                </div>
              </Trapclaim>
            </b-modal>
          </div>
          </button>
        </template>
        </div>
        <!--added Mortgage-->
        <!--ADD NEW Mortgage BUTTON-->
        </div>
      </div>
   <LayoutPropHorizontal :group="group" :pageData="pageData" :pagename="'mortgage'"></LayoutPropHorizontal>
     <div class="d-inline-block w-100">
        <button class="add-button btn btn-outline-success px-1 wsn select list-item px-3"
                tabindex="0" @keydown.enter.prevent.stop="addNewRuleForProperty(UrlAPI, 'mortgage')"
                @click.prevent="addNewRuleForProperty(UrlAPI, 'mortgage')" v-if="isInvisible() &&!isPolicyBound()">
                <icon name="plus-circle" scale="1.1" class="d-block mx-auto float-left"></icon>
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">Add Mortgage</div>
        </button>
     </div>
 </div>
</template>

<script>
/* eslint-disable */
import LayoutPropHorizontal from '@/components/presentational/layouts/LayoutPropHorizontal';
import { rulesMixin } from '@/mixins/rulesMixin';
import rulesAPI from '@/services/postData';
import common from '@/services/common';
import Trapclaim from 'vue-focus-lock';
import axios from '../../../axios-config';
import { pageMixin } from '@/mixins/pageMixin';

export default {
  props: ['group', 'pageData', 'sectionTitles','pageMixin'],
  mixins: [rulesMixin],
  inject: ['$validator'],
   data() {
    return {
     allSections: [],
     UrlAPI:'',
    };
  },
  components: {
    LayoutPropHorizontal,
    Trapclaim,
    
    },
    mounted(){
     this.UrlAPI="/rules/AddNewMortgage/QTE_PRP_MTG__Mtg",
     this.allSections = Object.keys(this.group);
    },
  methods: {
    isPolicyBound() {
      return (this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
    },
    isInvisible()
    {
     if (this.allSections.length<=2)
     return true;
     else
     return false;
    },
    closeModal(sectionModal) {
          
      this.$refs[sectionModal][0].hide();
    },
    groupSegments(sectionTitles) {
      let allSections = Object.keys(this.group);
      let sectionsToSend= allSections.filter(section=>{
        if(!sectionTitles.includes(section))
          return section;
      });
      sectionsToSend.forEach((element) => {
        delete this.group[element];
      });
      console.log('this.group covergae', this.group); 
      Object.keys(this.group).forEach((groupSegment, i) => {
        if (sectionTitles.indexOf(i) !== -1) {
          groupSegments[groupSegment] = this.group[groupSegment];
        }
      });
      return groupSegments;
    },
     promptDeleteSection(sectionModal) {
      this.$refs[sectionModal][0].show();
    },
  },
};
</script>
<style>
.vd-btn.list-item .delete{
    display: inline-block;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    line-height: 1em;
    cursor: pointer;
}
.list-item{
    display: inline-block;
    width: auto;
    height: auto;
    min-height: auto;
    float: none;
    margin: 0.25rem
}
.add-button{
    text-transform: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutMortgage.vue?5f61420d